import { MiscData } from './interface';

export const miscData: MiscData = {
  technologies: [
    {
      name: 'Node.js',
      url: 'https://nodejs.org/',
    },
    {
      name: 'TypeScript',
      url: 'https://www.typescriptlang.org/',
    },
    {
      name: 'React',
      url: 'https://reactjs.org/',
    },
    {
      name: 'create-react-app',
      url: 'https://create-react-app.dev/',
    },
    {
      name: 'Material UI',
      url: 'https://material-ui.com/',
    },
    {
      name: 'Font Awesome',
      url: 'https://fontawesome.com/',
    },
    {
      name: 'Cloudflare Pages',
      url: 'https://pages.cloudflare.com/',
    },
  ],
  quotes: [
    {
      // eslint-disable-next-line quotes
      sentence: "Don't worry. The hell is big enough for both of us.",
      origin: 'Clarke Griffin (The 100)',
    },
    {
      sentence:
        'You say having feelings makes us weak, but you are weak for hiding them.',
      origin: 'Clarke Griffin (The 100)',
    },
    {
      sentence: 'Life should be about more than just surviving.',
      origin: 'Clarke Griffin (The 100)',
    },
    {
      sentence: 'May we meet again.',
      origin: 'The 100',
    },
    {
      sentence: "Life is simple. You make choices, and you don't look back.",
      origin: 'Han (The Fast and the Furious: Tokyo Drift)',
    },
    {
      sentence: "Newton's third law. You gotta leave something behind.",
      origin: 'Cooper (Interstellar)',
    },
    {
      sentence: 'Ride or die, remember?',
      origin: 'Dominic Toretto (Fast & Furious 6)',
    },
    {
      sentence: 'Stories always have good ends, but reality does not.',
      origin: 'Alice (Detroit: Become Human)',
    },
    {
      sentence:
        "Forgetting who you are, to become what someone needs you to be. Maybe that's what it means to be alive.",
      origin: 'Luther (Detroit: Become Human)',
    },
    {
      sentence:
        'Do not worry about tomorrow, for tomorrow will worry about itself.',
      origin: 'Matthew 6:34',
    },
    {
      sentence:
        'We are enriched not by what we possess, but by what we can do without.',
      origin: 'Immanuel Kant',
    },
  ],
};
